<template>
  <div
    class="sm-window"
    :class="{ 'sm-full-screen': isFullScreen }"
    :style="windowSizeComputed"
    @click="$emit('showTabHandler')"
  >
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="header-btn" v-on:click.stop="$emit('visibilityToggle', false)">
        <Icon type="ios-close" />
      </div>
      <div class="header-btn fs-button" @click="fsToggle()">
        <Icon type="ios-browsers-outline" v-if="!isFullScreen" />
        <Icon type="ios-square-outline" v-if="isFullScreen" />
      </div>
    </div>
    <div class="content">
      <slot></slot>
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
import interact from 'interactjs'

export default {
  props: ['title', 'isVisible', 'top', 'left', 'bottom', 'right', 'ww', 'wh', 'zindex'],
  data () {
    return {
      isFullScreen: false,
      windowSize: {
        top: '84px',
        left: '84px',
        bottom: 'auto',
        right: 'auto',
        width: '600px',
        height: '400px',
        'z-index': 99
      }
    }
  },
  computed: {
    windowSizeComputed () {
      console.log('windowSize', this.windowSize)
      return this.windowSize
    }
  },
  methods: {
    fsToggle () {
      this.isFullScreen
        ? (this.isFullScreen = false)
        : (this.isFullScreen = true)
      console.log(this.isFullScreen)
    }
  },
  mounted () {
    this.windowSize = {
      transform: 'translate(0,0)',
      top: this.top,
      left: this.left,
      bottom: this.bottom,
      right: this.right,
      width: this.ww,
      height: this.wh,
      'z-index': this.zindex
    }

    interact(this.$el)
      .draggable({
        allowFrom: '.header',
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent'
          })
        ],
        // enable autoScroll
        autoScroll: true,
        // call this function on every dragend event
        onmove: (event) => {
          var target = event.target
          // keep the dragged position in the data-x/data-y attributes
          var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

          // translate the element
          target.style.webkitTransform = target.style.transform =
            'translate(' + x + 'px, ' + y + 'px)'

          // update the posiion attributes
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        }
      })
      .resizable({
        // resize from all edges and corners
        edges: { left: true, right: true, bottom: true, top: false },

        modifiers: [
          // keep the edges inside the parent
          interact.modifiers.restrictEdges({
            endOnly: true
          }),

          // minimum size
          interact.modifiers.restrictSize({
            min: { width: 100, height: 50 }
          })
        ]
      })
      .on('resizemove', (event) => {
        var target = event.target
        var x = parseFloat(target.getAttribute('data-x')) || 0
        var y = parseFloat(target.getAttribute('data-y')) || 0

        // update the element's style
        target.style.width = event.rect.width + 'px'
        target.style.height = event.rect.height + 'px'

        // translate when resizing from top or left edges
        x += event.deltaRect.left
        y += event.deltaRect.top

        target.style.webkitTransform = target.style.transform =
          'translate(' + x + 'px,' + y + 'px)'

        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      })
  },
  watch: {
    'zindex' () {
      this.windowSize = {
        transform: 'translate(0,0)',
        top: this.top,
        left: this.left,
        bottom: this.bottom,
        right: this.right,
        width: this.ww,
        height: this.wh,
        'z-index': this.zindex
      }
    }
  }
}
</script>
<style lang="scss" scoped>
body,
html {
  overflow: hidden;
  height: 100%;
}
.header {
  color: #222;
  background-color: #fff;
  padding: 4px 8px;
  display: inline-block;
  width: 100%;
  .title {
    float: left;
  }
  .header-btn {
    cursor: pointer;
    float: right;
    color: #222;
    font-size: 30px;
    line-height: 15px;
    .ivu-icon {
      line-height: 22px;
    }
  }
}

.content {
  height: calc(100% - 31px);
  position: relative;
  top: -5px;
  overflow: hidden;
  overflow-y: scroll;
  width: 100%;
}
.sm-window {
  border: 1px solid #dcdee2;
  background-color: #f5f5f5;
  border-bottom: 1px solid #dcdee2;
  touch-action: none;
  user-select: none;
  position: absolute;
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  z-index: 100;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.sm-full-screen {
  -webkit-transform: translate(0px, 0px) !important;
  transform: translate(0px, 0px) !important;
  width: calc(100%) !important;
  height: calc(100% - 64px) !important;
  top: 0px !important;
  left: 0px !important;
}
.fs-button {
  font-size: 18px !important;
}
.footer {
  height: 4px;
}
</style>
